// Browser-agnostic predicate for "this rejection is the request being aborted".
//
// The fetch spec dictates DOMException with name "AbortError", but we only
// look at `name` (not `instanceof DOMException`) because the polyfill paths
// in barcode-detector and some test mocks throw plain `Error` objects with
// that name. Treating any `{name:'AbortError'}` as an abort matches every
// real call site we've seen and avoids false positives — no other browser
// rejection uses that name.
export function isAbortError(err: unknown): boolean {
  return (err as { name?: string } | null | undefined)?.name === 'AbortError';
}
